// extracted by mini-css-extract-plugin
module.exports = {"view-report":"view-report-c111077abb99ed48ddbf6664e0ca5126"};